<template>
  <div class="stock-detail">
    <div
      v-if="stock"
      v-html="stock.text"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'StockDetail',
  props: {
    stockId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      stock: state => state.stock.stock
    })
  },
  mounted () {
    this.fetchStock(this.stockId)
  },
  methods: {
    ...mapActions({
      fetchStock: 'stock/fetch'
    })
  }
}
</script>

<style scoped>
@import 'https://news.demis.ru/css/client.css';
</style>
